module.exports = __webpack_public_path__ + "img/img_orderInfoBox.7799c2bf.png";